import get from 'lodash.get';
import { buildTrcObject } from '../../../../../../utils/shared/trcUtils';
import { BOOK_GENRES, LABEL } from '../../../../../../constants/shared/TrcConstants';
import { ICON } from '../../../../../../constants/shared/CommonConstants';

const { PAUSED } = ICON;
const { OBSERVATIONAL, N_LABEL } = LABEL;

export const getGenreLabel = key =>
    get(
        BOOK_GENRES.find(genre => genre.key === key),
        'label',
        N_LABEL,
    );

export const buildTrcBooks = result => {
    const { resultId, interp } = result;
    const booksResults = get(result, 'itemLevelDetails', []);
    const sortedBooks = booksResults.sort(
        ({ trcScore: score1 }, { trcScore: score2 }) => score1.dateCompleted < score2.dateCompleted,
    );
    return sortedBooks.map(({ trcScore }) => {
        const { resultSid, actualScore, bookType, complete } = trcScore;
        return {
            ...buildTrcObject(trcScore),
            interp: resultSid === resultId ? interp : '',
            actualScore: complete ? actualScore : PAUSED,
            genre: getGenreLabel(bookType),
            assessmentMode: OBSERVATIONAL,
        };
    });
};
